/* Keep physical orders in the cart until the delivery app has mounted.
 * DingDoong continues to own date validation, surcharges and checkout state.
 * This guard never changes the checkout button's native disabled property.
 */
(() => {
  'use strict';
  const checkoutSelector = '#kaching-cart .kaching-cart__checkout-button';
  const calendarSelector = '.ot-dingdoong-day-picker-container .ot-dingdoong-dropdown__button';

  function needsCalendar(cart) {
    if (!cart) return false;
    const physicalItems = [...cart.querySelectorAll('.kaching-cart-item')]
      .some(item => item.dataset.requiresShipping !== 'false');
    return physicalItems && !cart.querySelector(calendarSelector);
  }

  let sheet = null;
  let sheetOpener = null;
  function updateCalendarSheet(cart) {
    const content = cart?.querySelector('.ot-dingdoong-dropdown__content');
    if (!content || !content.getClientRects().length || getComputedStyle(content).visibility === 'hidden') {
      content?.removeAttribute('aria-modal');
      sheet = null;
      return;
    }
    const opener = cart.querySelector(calendarSelector);
    let close = content.querySelector('.j-calendar-close');
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.className = 'j-calendar-close';
      close.setAttribute('aria-label', 'Versandkalender schließen');
      close.textContent = 'Versandtag wählen · Schließen ×';
      close.addEventListener('click', event => {
        event.stopPropagation();
        opener?.click();
        opener?.focus();
      });
      content.prepend(close);
    }
    if (sheet !== content) {
      sheet = content;
      sheetOpener = opener;
      content.setAttribute('aria-label', 'Versandtag wählen');
      content.setAttribute('aria-modal', 'true');
      close.focus({ preventScroll: true });
    }
  }
  document.addEventListener('keydown', event => {
    if (!sheet?.isConnected || !sheet.getClientRects().length || getComputedStyle(sheet).visibility === 'hidden') return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      sheetOpener?.click();
      sheetOpener?.focus();
    } else if (event.key === 'Tab') {
      const controls = [...sheet.querySelectorAll('button,[tabindex],a[href]')]
        .filter(node => node.getClientRects().length && !node.disabled
          && node.getAttribute('aria-disabled') !== 'true' && node.tabIndex >= 0);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  }, true);

  function update() {
    const cart = document.getElementById('kaching-cart');
    updateCalendarSheet(cart);
    const button = cart?.querySelector('.kaching-cart__checkout-button');
    if (!button) return;
    const pending = needsCalendar(cart);
    let message = cart.querySelector('[data-j-calendar-status]');

    if (pending) {
      if (!button.hasAttribute('data-j-calendar-pending')) {
        button.dataset.jCalendarPending = '';
        button.dataset.jPreviousAriaDisabled = button.getAttribute('aria-disabled') || '';
        button.setAttribute('aria-disabled', 'true');
      }
      if (!message) {
        message = document.createElement('div');
        message.className = 'r-cart-calendar-status';
        message.dataset.jCalendarStatus = '';
        message.setAttribute('role', 'status');
        const text = document.createElement('p');
        text.textContent = 'Dein Versandkalender lädt noch. Falls er nicht erscheint, lade die Seite neu.';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = 'Neu laden';
        retry.addEventListener('click', () => window.location.reload());
        const help = document.createElement('a');
        help.href = '/pages/contact';
        help.textContent = 'Hilfe zur Bestellung';
        message.append(text, retry, help);
        button.insertAdjacentElement('beforebegin', message);
      }
    } else {
      if (button.hasAttribute('data-j-calendar-pending')) {
        const previous = button.dataset.jPreviousAriaDisabled;
        if (button.getAttribute('aria-disabled') === 'true') {
          if (previous) button.setAttribute('aria-disabled', previous);
          else button.removeAttribute('aria-disabled');
        }
        delete button.dataset.jCalendarPending;
        delete button.dataset.jPreviousAriaDisabled;
      }
      message?.remove();
    }
  }

  function stopPendingCheckout(event) {
    const button = event.target?.closest?.(checkoutSelector);
    const form = event.type === 'submit' && event.target?.id === 'CartDrawer-Form';
    if ((!button && !form) || !needsCalendar(document.getElementById('kaching-cart'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    update();
  }

  document.addEventListener('click', stopPendingCheckout, true);
  document.addEventListener('submit', stopPendingCheckout, true);
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-requires-shipping'] });
  update();
})();
